import jQuery from 'jquery'

(function($) {
  "use strict";
  $(document).ready(function() {
    if ($('#account__company__edit').length) {
      init_members_container();
    }

    if ($('#account__company__renewal,#account__personal__renewal').length) {
      init_renewal_page();
    }

    if ($('#account__company__new_members').length) {
      init_company_new_members_page();
    }
  });

  // ADD COMPANY MEMBER CONTAINER OBSERVER
  const init_members_container = function() {
    // sort member divs only on init
    const sort_by_position = function(a, b){
      var a_position = parseInt($(a).find('input[type="hidden"][name$="[position]"]').val());
      var b_position = parseInt($(b).find('input[type="hidden"][name$="[position]"]').val());
      return ((a_position < b_position) ? -1 : ((a_position > b_position) ? 1 : 0));
    }

    const $members_container = $('#members_container');
    const member_arr = $('#members_container .company-member').toArray().sort(sort_by_position);

    for (var i = 0, len = member_arr.length; i < len; i += 1) {
      $members_container.append(member_arr[i]);
    }

    const reset_members_container = function() {
      const $members = $('#members_container .company-member');
      for (var i = 0, len = $members.length; i < len; i += 1) {
        const $member = $members.eq(i),
              $btn_up = $member.find('button.position-up'),
              $btn_down = $member.find('button.position-down');

        // set up button
        $btn_up.unbind('click').show();

        if (i == 0) $member.find('button.position-up').hide();

        $btn_up.click(function() {
          $member.after($member.prev());
        });

        // set down button
        $btn_down.unbind('click').show();

        if (i == $members.length - 1) $member.find('button.position-down').hide();

        $btn_down.click(function() {
          $member.before($member.next());
        });

        // set position
        $member.find('.member-counter').text(i + 1);
        $member.find('input[type="hidden"][name$="[position]"]').val(i + 1);
      }
    }

    const watch_member_container = function() {
      const observer = new MutationObserver(records => {
        reset_members_container();
      });

      observer.observe($members_container[0], { childList: true });
    }

    reset_members_container();
    watch_member_container();
  }

  const init_renewal_page = function() {
    // toggle fields for renewal or unrenewal
    const set_renew_toggle = function() {
      if ($('input[name="renew"]:checked').val() == 1) {
        if ($('#renew0:visible').length) {
          $('#renew0').slideUp(function() {
            $('#renew1').slideDown();
          });
        }
      } else {
        if ($('#renew1:visible').length) {
          $('#renew1').slideUp(function() {
            $('#renew0').slideDown();
          });
        }
      }
    }

    $('input[name="renew"]').on('change', function() {
      set_renew_toggle();
    });

    set_renew_toggle();

    // remove fields before post for renewal or unrenewal
    $('form[action="/account/company/apply_renewal"]').submit(function() {
      if ($('input[name="renew"]:checked').val() == 1) {
        $('#renew0').remove();
      } else {
        $('#renew1').remove();
      }

      return true;
    });

    if ($('#account__company__renewal').length) {
      // set gray out for members table
      const grayoutrgb = $('#members_table tbody').data('gray_out_rgb');
      $('#members_table tbody tr td.contact-person').css('background-color', grayoutrgb);

      const set_bg_color_grayout_toggle = function($this) {
        if ($this.is(':checked')) {
          $this.closest('tr').css('background-color', grayoutrgb)
        } else {
          $this.closest('tr').css('background-color', '')
        }
      }

      $('#members_table tbody tr td input[name^="nonrenewal_member["]').on('change', function() {
        set_bg_color_grayout_toggle($(this));
      })

      const $nonrenewal_member_checkboxes = $('#members_table tbody tr td input[name^="nonrenewal_member["]');
      for (var i = 0, len = $nonrenewal_member_checkboxes.length; i < len; i++) {
        set_bg_color_grayout_toggle($nonrenewal_member_checkboxes.eq(i));
      }

      // toggle contact person fields
      const $name_field = $('#change_contact_person_name');
      const $email_field = $('#change_contact_person_email');
      const set_change_contact_person_container_toggle = function() {
        if ($('#change_contact_person:checked').length) {
          if ($('#change_contact_person_container:hidden').length) {
            $name_field.val($name_field.attr('tmp_val'));
            $email_field.val($email_field.attr('tmp_val'));
            $('#change_contact_person_container').slideDown();
          }
        } else {
          if ($('#change_contact_person_container:visible').length) {
            $('#change_contact_person_container').slideUp(function() {
              $name_field.attr('tmp_val', $name_field.val()).val('');
              $email_field.attr('tmp_val', $email_field.val()).val('');
            });
          }
        }
      }

      $('#change_contact_person').on('change', function() {
        set_change_contact_person_container_toggle();
      });

      set_change_contact_person_container_toggle();

      // toggle add members fields

      const set_add_members_container_toggle = function() {
        if ($('#add_members:checked').length) {
          if ($('#add_members_container:hidden').length) $('#add_members_container').slideDown();
        } else {
          if ($('#add_members_container:visible').length) $('#add_members_container').slideUp();
        }
      }

      $('#add_members').on('change', function() {
        set_add_members_container_toggle();
      });

      set_add_members_container_toggle();

      // member container
      const current_member_count = $('#members_table tbody tr').length - 1;
      const max_member_count = $('#add_members_container').data('max_members_count');
      const $members_container = $('#members_container');

      const reset_members_container = function() {
        const $delete_members = $('#members_container .company-member .delete-member');
        // SET DELETE MEMBER BUTTON
        $delete_members.unbind('click');
        if ($delete_members.length > 1) {
          $delete_members.show();

          $delete_members.bind('click', function() {
            const $company_member_container = $(this).closest('.company-member');
            $company_member_container.slideUp(function() {
              $company_member_container.remove();
            });
          });
        } else {
          $delete_members.hide();
        }

        // SET MEMBER COUNTER
        const $counters = $('#members_container .company-member .member-counter');
        $counters.text('');
        for (var i = 0, len = $counters.length; i < len; i += 1) {
          $counters.eq(i).text(i + current_member_count + 2);
        }

        reset_maskable_phones();
      }

      const watch_member_container = function() {
        const observer = new MutationObserver(records => {
          reset_members_container();
        });

        observer.observe($members_container[0], { childList: true });
      }

      reset_members_container();
      watch_member_container();
    }

  }

  const init_company_new_members_page = function() {
    const $members_container = $('#members_container');
    const current_member_count = parseInt($members_container.data('persisted_member_length')) + 1;
    const max_member_count = parseInt($members_container.data('max_members_count')) - current_member_count + 1;
    const $add_member_btn_container = $('#add_member_btn_container');

    const reset_members_container = function() {

      // SET ADD MEMBER BUTTON
      if ($('#members_container .company-member').length >= max_member_count) {
        if ($add_member_btn_container.is(':visible')) $add_member_btn_container.hide();
      } else {
        if ($add_member_btn_container.is(':hidden')) $add_member_btn_container.show();
      }

      const $delete_members = $('#members_container .company-member .delete-member');
      // SET DELETE MEMBER BUTTON
      $delete_members.unbind('click');
      if ($delete_members.length > 1) {
        $delete_members.show();

        $delete_members.bind('click', function() {
          const $company_member_container = $(this).closest('.company-member');
          $company_member_container.slideUp(function() {
            $company_member_container.remove();
          });
        });
      } else {
        $delete_members.hide();
      }

      // SET MEMBER COUNTER
      const $counters = $('#members_container .company-member .member-counter');
      $counters.text('');
      for (var i = 0, len = $counters.length; i < len; i += 1) {
        $counters.eq(i).text(i + current_member_count + 1);
      }

      reset_maskable_phones();
    }

    const watch_member_container = function() {
      const observer = new MutationObserver(records => {
        reset_members_container();
      });

      observer.observe($members_container[0], { childList: true });
    }

    reset_members_container();
    watch_member_container();
  }

})(jQuery);
